/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export const DEVELOPMENT = 'development';
export const TIME_FORMAT = 'SYS:yyyy-mm-dd HH:MM:ss';
export const DEFAULT_LOG_LEVEL = 'info';
export const DEFAULT_CENSOR_STRING = '****';
